import actions from './actions';
// import initialState from '../../demoData/usersData.json';

const {
  CUSTOMER_LIST_BEGIN,
  CUSTOMER_LIST_SUCCESS,
  CUSTOMER_LIST_ERR,
} = actions;

const initialState = {
  data: null,
  loading: true,
  error: null,
};

const customersReducer = (state = initialState, action) => {
  const { type,data,err } = action;
  switch (type) {
    case CUSTOMER_LIST_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case CUSTOMER_LIST_SUCCESS:
      return {
        ...state,
        data,
        loading: false,
      };
    case CUSTOMER_LIST_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

export { customersReducer};
